<template>
  <!-- レポート作成 -->
  <div id="HolterAnalysisJugdmentMonthlyReport">
    <div id="container-center">
      <div class="labelTitle lable">ホルター心電図判定 月次レポート</div>
      <!--検索条件 -->
      <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>判定期限</th><td style="width:400px;"><input type="date" v-model="searchConditions.judgmentDocterAnalysisLimitStart" /> ～ <input type="date" v-model="searchConditions.judgmentDocterAnalysisLimitEnd"/></td>
              <th>判定医名</th>
              <td style="width:400px;">
                <input type="text" style="width:270px;" disabled="disabled" v-model="searchConditions.judgmentDoctorName"/>
                <b-button v-if="userInfo.roleId !== role.role_holter_judgment" style="margin-left:10px; width:150px; height:27px;" @click="holterJudgmentModalActive=true">判定医選択</b-button>
              </td>
            </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>

      </div>
      <!-- 検索結果 -->
      <div v-if="hasResult">
        <div id="item-contens">
            <div class="card-content margin-top">
                <table>
                    <tr><th>判定期限</th><td>{{searchConditions.judgmentDocterAnalysisLimitStart}} ～ {{searchConditions.judgmentDocterAnalysisLimitEnd}}</td></tr>
                    <tr><th>判定医名</th><td>{{searchConditions.judgmentDoctorName}}</td></tr>
                </table>
            </div>
        </div>  
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('holteranalysisJugdmentMonthlyReportTable')">クリップボードにコピー</b-button>
        </div>
        <div class="table-wrapper">
            <table id="holteranalysisJugdmentMonthlyReportTable">
                <thead>
                    <tr>
                      <th></th>
                      <th>受付番号</th>
                      <th>判定期限日</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, index) in data">
                        <tr :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{row.receiptNumber}}</td>
                            <td>{{row.judgmentDocterAnalysisLimit}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>

    </div>
    <b-modal
      :active.sync="holterJudgmentModalActive"
      has-modal-card>
      <HolterJudgmentModal
        title="判定医選択"
        label-for-org="判定医"
        @select="setAnalyist"/>
    </b-modal>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import HolterJudgmentModal from '@/components/mock/philips/common/HolterJudgmentModal'

export default {
  name: "HolterAnalysisJugdmentMonthlyReport",
  methods: {
    doSearch: function() {
      if (!this.inputCheck()) {
        return;
      }

      
      
      this.data = []
      this.hasResult = false
      const excuteApi = this.getHolterAnalysisResultApprovalListPOST
      const successCallBack = this.getHolterAnalysisResultApprovalListPOSTSuccess
      const errorCallBack = this.getHolterAnalysisResultApprovalListPOSTError
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getHolterAnalysisResultApprovalListPOST: function (client) {
      const obj = JSON.parse(JSON.stringify(this.searchConditions))
      return client.apis.apiCommon.getHolterJudgmentListPOST({
        body: obj
      })
    },
    getHolterAnalysisResultApprovalListPOSTSuccess: function (result) {
      // 検索結果取得
      this.data = result.obj
      this.data.sort((a, b) => {
        return new Date(a.judgmentDocterAnalysisLimit) - new Date(b.judgmentDocterAnalysisLimit)
      })
      this.hasResult = true
    },
    getHolterAnalysisResultApprovalListPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
    },
    inputCheck: function() {
      if (!this.searchConditions.judgmentDocterAnalysisLimitStart || !this.searchConditions.judgmentDocterAnalysisLimitEnd) {
        this.showErrorMessage('判定期限を入力してください。');
        return false
      }

      if (this.searchConditions.judgmentDocterAnalysisLimitStart > this.searchConditions.judgmentDocterAnalysisLimitEnd) {
        this.showErrorMessage('判定期限の開始/終了の関係に誤りがあります。');
        return false
      }

      if (!this.searchConditions.judgmentDoctorName) {
        this.showErrorMessage('判定医を選択してください。');
        return false
      }

      return true
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      navigator.clipboard.writeText(btable.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    back: function() {
      this.$router.go(-1);
    },
    
    setAnalyist: function (analyistInfo) {
      this.searchConditions.judgmentDocterId = analyistInfo.id
      this.searchConditions.judgmentDoctorName = analyistInfo.doctorName
    },
  },
  data() {
    var holteranalysisList = this.getChoiceList(choicesType.holterKind, true)
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    return {
        role: role,
        searchConditions:{
          status: "20",
          judgmentDocterId: null,
          judgmentDoctorName: "",
        },
        data: [],
        holteranalysisList: holteranalysisList,
        userInfo,
        hasResult: false,
        holterJudgmentModalActive: false
    };
  },
  filters: {},
  components: {
    HolterJudgmentModal: HolterJudgmentModal
  },
  mounted: function() {
    if(this.userInfo.roleId == role.role_holter_judgment){
      this.searchConditions.judgmentDocterId = this.userInfo.id
      this.searchConditions.judgmentDoctorName = this.userInfo.lastName + " " + this.userInfo.firstName
    }
  }
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
.table-wrapper {
    max-height: 1100px;
    overflow-y: scroll;
}
#holteranalysisJugdmentMonthlyReportTable {
    font-size: 100% !important;
}
#holteranalysisJugdmentMonthlyReportTable tr,
#holteranalysisJugdmentMonthlyReportTable th,
#holteranalysisJugdmentMonthlyReportTable td{
    border: black 1px solid;
    text-align: center;
    word-break : break-all;
}
#holteranalysisJugdmentMonthlyReportTable td{
    width: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/guest/HolterAnalysisJugdmentMonthlyReport.vue